/** 极速时时彩 · 兩面 — 靜態結構（接口接入後替換） */

export const CANADA20_LOTTERY_NAME = '加拿大2.0'

/** PC28 大網盤：玩法與介面與加拿大2.0 一致 */
export const PC28_DAWANGPAN_LOTTERY_NAME = 'PC28大网盘'

/** 與左側 JND2 菜單一致，供頂欄「玩法」下拉使用（長龍置於和值之下） */
export const playTypesCanada20 = ['主势盘', '1-3位置', '和值', '二字定位', '三字定位', '长龙']

export function isCanada20Lottery(name) {
  return (
    name === CANADA20_LOTTERY_NAME ||
    name === PC28_DAWANGPAN_LOTTERY_NAME ||
    name === '极速蛋蛋'
  )
}

export const lotteryTypes = [
  '极速时时彩',
  '幸运飞艇',
  '极速赛车',
  '极速飞艇',
  '澳洲幸运5',
  '澳洲幸运10',
  CANADA20_LOTTERY_NAME,
  PC28_DAWANGPAN_LOTTERY_NAME,
  '极速番摊'
]

export const playTypes = [
  '兩面',
  '單球1-5',
  '第一球',
  '第二球',
  '第三球',
  '第四球',
  '第五球'
]

export const wagerSections = [
  {
    title: '第一球',
    options: [
      { name: '大', odds: '' },
      { name: '小', odds: '' },
      { name: '单', odds: '' },
      { name: '双', odds: '' }
    ]
  },
  {
    title: '第二球',
    options: [
      { name: '大', odds: '' },
      { name: '小', odds: '' },
      { name: '单', odds: '' },
      { name: '双', odds: '' }
    ]
  },
  {
    title: '第三球',
    options: [
      { name: '大', odds: '' },
      { name: '小', odds: '' },
      { name: '单', odds: '' },
      { name: '双', odds: '' }
    ]
  },
  {
    title: '第四球',
    options: [
      { name: '大', odds: '' },
      { name: '小', odds: '' },
      { name: '单', odds: '' },
      { name: '双', odds: '' }
    ]
  },
  {
    title: '第五球',
    options: [
      { name: '大', odds: '' },
      { name: '小', odds: '' },
      { name: '单', odds: '' },
      { name: '双', odds: '' }
    ]
  },
  {
    title: '總和、龍虎',
    options: [
      { name: '总单', odds: '' },
      { name: '总双', odds: '' },
      { name: '总大', odds: '' },
      { name: '总小', odds: '' },
      { name: '龙', odds: '' },
      { name: '虎', odds: '' },
      { name: '和', odds: '' }
    ]
  }
]

export const longDragonItems = [
  { text: ' 第一球 - 大:', count: '0期' },
  { text: ' 第一球 - 小:', count: '2期' },
  { text: ' 第一球 - 单:', count: '6期' },
  { text: ' 第一球 - 双:', count: '0期' },
  { text: ' 第二球 - 大:', count: '0期' },
  { text: ' 第二球 - 小:', count: '4期' },
  { text: ' 第二球 - 单:', count: '0期' },
  { text: ' 第二球 - 双:', count: '2期' },
  { text: ' 第三球 - 大:', count: '0期' },
  { text: ' 第三球 - 小:', count: '0期' },
  { text: ' 第三球 - 单:', count: '0期' },
  { text: ' 第三球 - 双:', count: '2期' },
  { text: ' 第四球 - 大:', count: '0期' },
  { text: ' 第四球 - 小:', count: '0期' },
  { text: ' 第四球 - 单:', count: '2期' },
  { text: ' 第四球 - 双:', count: '0期' },
  { text: ' 第五球 - 大:', count: '0期' },
  { text: ' 第五球 - 小:', count: '0期' },
  { text: ' 第五球 - 单:', count: '0期' },
  { text: ' 第五球 - 双:', count: '0期' },
  { text: ' 总和 - 大:', count: '0期' },
  { text: ' 总和 - 小:', count: '4期' },
  { text: ' 总和 - 单:', count: '0期' },
  { text: ' 总和 - 双:', count: '0期' },
  { text: ' 龙:', count: '0期' },
  { text: ' 虎:', count: '2期' },
  { text: ' 和:', count: '0期' },
]

/** 加拿大2.0 · 兩面長龍排行 */
export const longDragonItemsCanada20 = [
  { text: ' 大小 - 大:', count: '0期' },
  { text: ' 大小 - 小:', count: '0期' },
  { text: ' 单双 - 单:', count: '0期' },
  { text: ' 单双 - 双:', count: '0期' },
  { text: ' 第一球 - 大:', count: '0期' },
  { text: ' 第一球 - 小:', count: '0期' },
  { text: ' 第一球 - 单:', count: '0期' },
  { text: ' 第一球 - 双:', count: '0期' },
  { text: ' 第二球 - 大:', count: '0期' },
  { text: ' 第二球 - 小:', count: '0期' },
  { text: ' 第二球 - 单:', count: '0期' },
  { text: ' 第二球 - 双:', count: '0期' },
  { text: ' 第三球 - 大:', count: '0期' },
  { text: ' 第三球 - 小:', count: '0期' },
  { text: ' 第三球 - 单:', count: '0期' },
  { text: ' 第三球 - 双:', count: '0期' },
  { text: ' 龙虎和 - 龙:', count: '0期' },
  { text: ' 龙虎和 - 虎:', count: '0期' },
  { text: ' 龙虎和 - 和:', count: '0期' },
]

export const ballNavLabels = [
  '第1球大小',
  '第1球單雙',
  '第2球大小',
  '第2球單雙',
  '第3球大小',
  '第3球單雙',
  '第4球大小',
  '第4球單雙',
  '第5球大小',
  '第5球單雙',
  '總和大小',
  '總和單雙',
  '龍虎'
]

/** 單球1-5 / 第N球：每球 0-9，id 與原站 sn_205～sn_209 一致 */
const DAN_QIU_SN = [205, 206, 207, 208, 209]
const DAN_QIU_TITLES = ['第一球', '第二球', '第三球', '第四球', '第五球']

function oddsForDanQiu(ballIdx, num) {
  return ''
}

export const wagerSectionsDanQiu15 = DAN_QIU_TITLES.map((title, ballIdx) => ({
  title,
  snPrefix: DAN_QIU_SN[ballIdx],
  cells: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => ({
    num,
    odds: oddsForDanQiu(ballIdx, num)
  }))
}))

/** 第一球～第五球：首塊 0-9 + 該球大小單雙 + 總和龍虎；再前三/中三/后三 */
export function getSingleBallLayout(ballIdx) {
  const numSn = DAN_QIU_SN[ballIdx]
  const dxSn = 210 + ballIdx
  const dsSn = 215 + ballIdx
  const firstCells = []
  for (let n = 0; n <= 9; n++) {
    firstCells.push({
      kind: 'num',
      num: n,
      sn: numSn,
      sub: n,
      odds: oddsForDanQiu(ballIdx, n)
    })
  }
  firstCells.push(
    { kind: 'text', label: '大', sn: dxSn, sub: 1, odds: '' },
    { kind: 'text', label: '小', sn: dxSn, sub: 2, odds: '' },
    { kind: 'text', label: '单', sn: dsSn, sub: 1, odds: '' },
    { kind: 'text', label: '双', sn: dsSn, sub: 2, odds: '' },
    { kind: 'text', label: '总大', sn: 346, sub: 1, odds: '' },
    { kind: 'text', label: '总小', sn: 346, sub: 2, odds: '' },
    { kind: 'text', label: '总单', sn: 345, sub: 1, odds: '' },
    { kind: 'text', label: '总双', sn: 345, sub: 2, odds: '' },
    { kind: 'text', label: '龙', sn: 347, sub: 1, odds: '' },
    { kind: 'text', label: '虎', sn: 347, sub: 2, odds: '' },
    { kind: 'text', label: '和', sn: 347, sub: 3, odds: '' }
  )
  const sanxing = [
    {
      title: '前三',
      options: [
        { label: '豹子', sn: 330, sub: 1, odds: '' },
        { label: '顺子', sn: 333, sub: 1, odds: '' },
        { label: '对子', sn: 336, sub: 1, odds: '' },
        { label: '半顺', sn: 339, sub: 1, odds: '' },
        { label: '杂六', sn: 342, sub: 1, odds: '' }
      ]
    },
    {
      title: '中三',
      options: [
        { label: '豹子', sn: 331, sub: 1, odds: '' },
        { label: '顺子', sn: 334, sub: 1, odds: '' },
        { label: '对子', sn: 337, sub: 1, odds: '' },
        { label: '半顺', sn: 340, sub: 1, odds: '' },
        { label: '杂六', sn: 343, sub: 1, odds: '' }
      ]
    },
    {
      title: '后三',
      options: [
        { label: '豹子', sn: 332, sub: 1, odds: '' },
        { label: '顺子', sn: 335, sub: 1, odds: '' },
        { label: '对子', sn: 338, sub: 1, odds: '' },
        { label: '半顺', sn: 341, sub: 1, odds: '' },
        { label: '杂六', sn: 344, sub: 1, odds: '' }
      ]
    }
  ]
  return {
    boxTitle: DAN_QIU_TITLES[ballIdx],
    firstCells,
    sanxing
  }
}

/** 第N球頁 · 兩面長龍（演示） */
export const longDragonItemsSingleBall = [
  { text: ' 第一球 - 大:', count: '0期' },
  { text: ' 第一球 - 小:', count: '3期' },
  { text: ' 第一球 - 单:', count: '7期' },
  { text: ' 第一球 - 双:', count: '0期' },
  { text: ' 第二球 - 大:', count: '0期' },
  { text: ' 第二球 - 小:', count: '0期' },
  { text: ' 第二球 - 单:', count: '0期' },
  { text: ' 第二球 - 双:', count: '3期' },
  { text: ' 第三球 - 大:', count: '0期' },
  { text: ' 第三球 - 小:', count: '2期' },
  { text: ' 第三球 - 单:', count: '0期' },
  { text: ' 第三球 - 双:', count: '0期' },
  { text: ' 第四球 - 大:', count: '0期' },
  { text: ' 第四球 - 小:', count: '0期' },
  { text: ' 第四球 - 单:', count: '3期' },
  { text: ' 第四球 - 双:', count: '0期' },
  { text: ' 第五球 - 大:', count: '2期' },
  { text: ' 第五球 - 小:', count: '0期' },
  { text: ' 第五球 - 单:', count: '2期' },
  { text: ' 第五球 - 双:', count: '0期' },
  { text: ' 龙:', count: '0期' },
  { text: ' 虎:', count: '3期' },
  { text: ' 和:', count: '0期' },
]

/** 兩面 / 第N球「大小」排行條（paihang） */
export const rankPanelFirst = [
  ['小'],
  ['大'],
  ['小'],
  ['大'],
  ['小', '小'],
  ['大', '大', '大', '大', '大'],
  ['小'],
  ['大', '大', '大'],
  ['小', '小'],
  ['大', '大', '大', '大', '大']
]

/** 第N球頁 · 球號排行 6 組（與原頁 tab 順序一致） */
export const rankPanelsSingleBall = [
  [['0'], ['5'], ['9'], ['8'], ['3'], ['1'], ['8', '8'], ['5'], ['7'], ['8']],
  rankPanelFirst,
  [
    ['单'],
    ['双'],
    ['单', '单', '单', '单'],
    ['双', '双', '双'],
    ['单', '单'],
    ['双'],
    ['单', '单'],
    ['双', '双'],
    ['单', '单'],
    ['双']
  ],
  [
    ['小'],
    ['大', '大'],
    ['小'],
    ['大', '大'],
    ['小', '小', '小'],
    ['大'],
    ['小'],
    ['大', '大', '大'],
    ['小', '小'],
    ['大', '大']
  ],
  [
    ['双'],
    ['单', '单'],
    ['双'],
    ['单', '单', '单'],
    ['双'],
    ['单'],
    ['双', '双', '双', '双'],
    ['单', '单', '单', '单'],
    ['双', '双'],
    ['单']
  ],
  [
    ['虎'],
    ['龙', '龙', '龙'],
    ['和'],
    ['虎', '虎', '虎', '虎'],
    ['龙', '龙'],
    ['虎'],
    ['龙', '龙', '龙'],
    ['虎', '虎', '虎'],
    ['龙', '龙'],
    ['虎', '虎']
  ]
]